import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login','loginAD', 'registeruser', 'logout'])
export const authFackComputed = {
  ...mapState('authfack', {
    currentUser: (state) => state.user,
  }),
  ...mapGetters('authfack', ['loggedInAdmin']),
}
export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', [
  'addCategories',
  'fethcategoriesAll',
  'updateCategories',
  'fethallClients',
  'fethListproduct',
  'fetchProductbyId',
  'fethupdateProducto',
  'fethusaveProducto',
  'fethdeleteProducto',
  'fetchuserList',
  'fetchCreateUser',
  'fethusaveFiles',
  'fethusaveCoverFiles',
  'fethListimages',
  'fethusaveImport',
  'fethdeleteSelectProductos',
  'fethudeleteFiles',
  

  'fethgetallResistenciasMecanicas',
  'fethgetReferenceCode',
  'fethregisterQuote',
  'fethgetallQuote',
  'fethgetallTipoanillo',
  'fethgetallTipoherraje',
  'fethgetQuoteAnality',
  'fethregisterClient',
  'fethallClient',
  'fetchQuotebyId',
  'fethClientsbyId',
  'fethallCentroCostos',
  'fethallClasesActivida',
  'fethallMaterials',
  'fethupdatematerials',
  'fethallPuestoTrabajo',
  'fethallReferencia',
  'fethvariables',
  'fethupdatevariables',
  'fethservicioAll',
  'fethupdateservicio',
  'fethAddreferencia',
])